// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__RPiI2","background":"Popup_background__HS2Fz","backgroundAppear":"Popup_backgroundAppear__zwwpp","content":"Popup_content__FOQOI"};